import React from 'react';
import RunLog from '@/components/RunLog';

const Hero = () => (
  <section className="hero" data-testid="hero-section">
    <div className="wrap hero-grid">
      <div className="hero-copy">
        <h1 className="reveal" data-testid="hero-title">
          <span className="line">Automate the work</span>
          <span className="line">that slows you down.</span>
        </h1>
        <p className="lead reveal reveal-1" data-testid="hero-subtitle">
          Rapid Rune builds automation and IT systems that cut repetitive manual work. Your team focuses on what moves the business.
        </p>
        <div className="hero-actions reveal reveal-2">
          <a href="#contact" className="btn btn-accent" data-testid="hero-cta-primary">
            Start a project
            <Arrow />
          </a>
          <a href="#services" className="link-arrow" data-testid="hero-cta-secondary">
            See what we build
          </a>
        </div>
        <p className="hero-note reveal reveal-3">
          Fixed price after one scoping call. Most projects live in three to six weeks.
        </p>
      </div>

      <div className="hero-runlog reveal reveal-1">
        <RunLog />
      </div>
    </div>
  </section>
);

export const Arrow = () => (
  <svg className="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="square" aria-hidden="true">
    <path d="M4 12h15M13 6l6 6-6 6" />
  </svg>
);

export default Hero;
